import React from 'react';
import classNames from 'classnames';

import './Card.css';

const Card = ({
  children,
  className,
  bgColor = 'bg-1',
  ...props
}) => {
  const cardClasses = classNames('card', `bg-${bgColor}`, className);

  return (
    <div className={cardClasses} {...props}>
      {children}
    </div>
  );
};

export default Card;
